import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentState: {
    partner: 0,
    branch: 0,
    day: 0,
  },
  show: false,
};

const reportClockSlice = createSlice({
  name: "reportClock",
  initialState,
  reducers: {
    setCurrentState: (state, action) => {
      state.currentState = action.payload;
    },
    setShow: (state, action) => {
      state.show = action.payload;
    },
  },
});

export const { setCurrentState, setShow } = reportClockSlice.actions;
export default reportClockSlice.reducer;
